module.exports = __webpack_public_path__ + "741d44479cea3a1d56fd0e02ce98d7fc.pdf";